import { relatedProductsData } from '../components/ProductsData';

export const getItemsByIds = (itemIds) => {
    return itemIds.map(id => relatedProductsData.find(item => item.id === id));
};
